import { firebase } from './api/firebase'
import { firebaseAction } from 'vuexfire'

const environment = require('../environments/production')

const state = {
  authResult: {},
  credential: null,
  funds: {
    balance: 0,
    downline: false,
    standardSizes: false
  },
  isRegistering: false, // gets set to true when user is registering
  transactions: [],
  paymentSources: [],
  profileData: {},
  detachFunds: null,
  uid: null,
  isVerified: false,
  displayName: null,
  groupId: null,
  loginError: null,
  loggedOut: null,
  apiTokens: {},
  groupData: {},
  groups: []
}

const getters = {
  getAuthResult: state => {
    // console.log('getting authResults: ', JSON.stringify(state.authResult, null, 2))
    return state.authResult
  },
  getTransactionHistory: state => {
    let charges = state.transactions.slice().reverse()
    let computedCharges = []
    charges.forEach(charge => {
      computedCharges.push({
        created: new Date(charge.created * 1000).toLocaleString(),
        source: `${charge.source.brand}: ${charge.source.last4}`,
        amount: parseInt(charge.amount / 100, 10).toFixed(2),
        paid: charge.paid
      })
    })
    return computedCharges
  },
  getFunds: state => {
    return state.funds.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  getDownline: state => {
    return state.funds.downline
  },
  getCredential: state => {
    return state.credential
  },
  getProfileData: state => {
    return state.profileData
  },
  getUser: state => {
    return state.uid
  },
  getGroupId: state => {
    return state.groupId
  },
  getLoginError: state => {
    return state.loginError
  },
  getBooteekToken: state => {
    return state.apiTokens.booteek360
  },
  getSonletToken: state => {
    return state.apiTokens.sonlet
  },
  booteekLinked: (state, getters) => {
    return (typeof getters.getBooteekToken !== 'undefined')
  },
  sonletLinked: (state, getters) => {
    return (typeof getters.getSonletToken !== 'undefined')
  }
}

const mutations = {
  setAuthResult: (state, payload) => {
    state.authResult = payload
  },
  setCredential: (state, payload) => {
    state.credential = payload
  },
  setProfileData: (state, payload) => {
    state.profileData = payload
  },
  setLoginError: (state, payload) => {
    state.loginError = payload
  },
  setFunds: (state, payload) => {
    state.funds = payload
  },
  // setStandardSizes: (state, payload) => {
  //   state.funds.standardSizes = payload
  // },
  detachFunds: (state, payload) => {
    state.detachFunds = payload
  },
  setUser: (state, payload) => {
    state.uid = payload
  },
  setIsVerified: (state, payload) => {
    state.isVerified = payload
  },
  setDisplayName: (state, payload) => {
    state.displayName = payload
  },
  setGroupId: (state, payload) => {
    state.groupId = payload
  },
  setGroupData: (state, payload) => {
    state.groupData = payload
  },
  setLoggedOut: (state, payload) => {
    state.loggedOut = payload
  },
  setRegistration: (state, payload) => {
    state.isRegistering = payload
  }
}
const actions = {
  getApiTokens: firebaseAction(context => {
    let ref = firebase.database().ref(environment.schema.apiTokens).child(context.state.uid)
    context.bindFirebaseRef('apiTokens', ref)
  }),
  pullTransactionHistory: firebaseAction(context => {
    let ref = firebase.database().ref(environment.schema.stripeCustomers).child(context.state.uid).child('charges')
    context.bindFirebaseRef('transactions', ref)
  }),
  detachTransactionHistory: firebaseAction(context => {
    if (context.state.transactions.length > 0) {
      context.unbindFirebaseRef('transactions')
    }
  }),
  getPaymentSources: firebaseAction(context => {
    let ref = firebase.database().ref(environment.schema.stripeCustomers).child(context.state.uid).child('sources')
    context.bindFirebaseRef('paymentSources', ref)
  }),
  detachPaymentSources: firebaseAction(context => {
    try {
      context.unbindFirebaseRef('paymentSources')
    } catch (e) {
      // throwaway e
    }
  }),
  getGroups: firebaseAction(context => {
    // console.log('in getGroups with user: ', context.state.uid)
    if (context.state.uid === 'ZFvomQD71Bhf2ckUDSeRVNfkeEw2') {
      // console.log('binding ref to groups: ')
      window.firebase = firebase
      context.bindFirebaseRef('groups', firebase.database().ref('/groups'))
    }
  }),
  setCredential: (context, payload) => {
    context.commit('setCredential', payload)
  },
  detachFunds: firebaseAction(context => {
    try {
      context.unbindFirebaseRef('funds')
    } catch (e) {
      // deal with e
    }
  }),
  setRegistration: (context, payload) => {
    context.commit('setRegistration', payload)
  },
  setAuthResult: (context, payload) => {
    context.commit('setAuthResult', payload)
  },
  setFunds: firebaseAction(context => {
    let ref = firebase.database().ref(environment.schema.accounts).child(context.state.groupId)
    // console.log('setFunds ref: ', ref.toString())
    context.bindFirebaseRef('funds', ref)
  }),
  setStandardSizes: (context, payload) => {
    return firebase.database().ref(environment.schema.accounts).child(context.state.groupId).update({
      standardSizes: payload
    })
  },
  setUser: (context, uid) => {
    context.commit('setUser', uid)
  },
  setIsVerified: (context, emailVerified) => {
    context.commit('setIsVerified', emailVerified)
  },
  setDisplayName: (context, name) => {
    context.commit('setDisplayName', name)
  },
  setGroupId: (context, payload) => {
    // we need to see if the user has a group that they are a collaborator in otherwise default to payload value.
    let groupIdToUse = payload // default to the user's group.
    let groupData = {}
    return firebase.database().ref(environment.schema.groups).child(context.state.uid).once('value')
      .then(snap => {
        if (snap.exists()) {
          // console.log('inside snap exists...')
          // need to loop over the groups to see which is default and then use that as the user's groupId
          snap.forEach(group => {
            let data = group.val()
            if (data.default) {
              groupIdToUse = group.key
              groupData = data
            }
          })
        }
      })
      .then(() => {
        context.commit('setGroupId', groupIdToUse)
        context.commit('setGroupData', groupData)
        // console.log('state got groupId: ', groupIdToUse)
        context.dispatch('setFunds')
        context.dispatch('getApiTokens')
      })
  },
  setLoggedOut: (context, b) => {
    context.commit('setLoggedOut', b)
  },
  loginWithFacebook: context => {
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(() => {
      let provider = new firebase.auth.FacebookAuthProvider()
      provider.addScope('email')
      // firebase.auth().getRedirectResult().then(result => {
      firebase.auth().signInWithPopup(provider).then(result => {
        // console.log('loginWithFacebook: ', JSON.stringify(result))
        if (result.user === null) {
          throw new Error('null user')
        }
        let profile = result.additionalUserInfo.profile
        // localStorage.setItem('authResult', JSON.stringify(Object.assign({}, profile)))
        context.commit('setAuthResult', profile)
        context.commit('setCredential', result.credential)
        context.dispatch('setGroupId', profile.id) // 127470647675333 // need to switch this to profile.id example: "10154979856454231"
        context.commit('setLoginError', null)
        context.commit('setLoggedOut', false)
        // if (context.state.isRegistering) {
        //   // we have a registration in progress...
        //   console.log('is registering dispatch setAuthResult...')
        context.dispatch('setAuthResult', Object.assign({}, profile))
        // } else {
        //  // user is registered and we're logging in
        context.commit('setProfileData', profile) // this will get or set profile data...
        context.dispatch('setLastLogin')
      }).catch(error => {
        // console.log(error)
        if (error.message === 'null user') {
          firebase.auth().signInWithRedirect(provider)
        } else {
          context.commit('setLoginError', error)
        }
      })
    })
  },
  setLastLogin: context => {
    // set timestamp
    // console.log('setting up user last seen data...')
    let ref = firebase.database().ref('user-last-seen').child(context.state.uid)
    // console.log('last seen ref: ', ref.toString())
    return ref.set({
      groupId: context.state.groupId,
      name: context.state.profileData.name,
      email: context.state.profileData.email,
      lastLoggedIn: new Date().toISOString(),
      lastLoggedInLocalTime: new Date().toLocaleString(),
      timestamp: new Date().getTime()
    })
  },
  getRedirectResult: context => {
    firebase.auth().getRedirectResult().then(result => {
      // firebase.auth().signInWithPopup(provider).then(result => {
      // console.log('getRedirectResult: ', JSON.stringify(result))
      if (result.user === null) {
        throw new Error('null user')
      }
      let profile = result.additionalUserInfo.profile
      // localStorage.setItem('authResult', JSON.stringify(Object.assign({}, profile)))
      context.commit('setCredential', result.credential)
      context.dispatch('setGroupId', profile.id) // 127470647675333 // need to switch this to profile.id example: "10154979856454231"
      context.commit('setLoginError', null)
      context.commit('setLoggedOut', false)
      if (context.state.isRegistering) {
        // we have a registration in progress...
        profile.isNewUser = result.additionalUserInfo.isNewUser
        context.dispatch('setAuthResult', Object.assign({}, profile))
      } else {
        // user is registered and we're logging in
        context.commit('setProfileData', profile) // this will get or set profile data...
        // context.dispatch('setFunds')
      }
    }).catch(error => {
      // console.log(error)
      if (error) {
        // no opp with the error
      }
    })
  },
  logout: context => {
    firebase.auth().signOut().then(() => {
      context.commit('setCredential', {})
      context.commit('setDisplayName', null)
      context.commit('setIsVerified', false)
      context.commit('setGroupId', null)
      context.commit('setLoginError', null)
      context.commit('setLoggedOut', true)
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user.js